export { default } from './GlobalConfigs';
